import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { AlertCircle } from "lucide-react";

const PaymentFailedPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-red-50 to-white px-4">

      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="bg-white shadow-2xl rounded-2xl p-10 max-w-md w-full text-center border border-red-100"
      >

        {/* Failed Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, type: "spring" }}
          className="flex justify-center mb-6"
        >
          <AlertCircle className="w-20 h-20 text-red-500" />
        </motion.div>

        {/* Heading */}
        <h1 className="text-4xl font-extrabold text-red-700 mb-4">
          Payment Failed
        </h1>

        {/* Message */}
        <p className="text-gray-700 text-lg mb-8">
          Unfortunately, your payment could not be completed.
          <br />
          Please try again or choose another payment method.
        </p>

        {/* Retry Button */}
       

        {/* Home Button */}
        <Link
          to="/menu-app"
          className="inline-block px-6 py-2 rounded-full bg-amber-600 text-white font-semibold hover:bg-amber-700 transition"
        >
          Go To Home
        </Link>

      </motion.div>
    </div>
  );
};

export default PaymentFailedPage;